import { Validators } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-association-dates-form',
  templateUrl: './association-dates-form.component.html',
  styleUrls: ['./association-dates-form.component.css']
})
export class AssociationDatesFormComponent implements OnInit {
  form: FormGroup;
  invalidSubmit = false;
  @Input() selectedAssociation: any;
  @Output() associationDates: EventEmitter<{startDate: string, endDate: string}> = new EventEmitter();

  constructor(
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.setData(this.selectedAssociation);
  }

  setData(data: any) {
    if (data.date_start && data.date_end) {
      this.form = this.fb.group({
        startDate: [new Date(data.date_start), Validators.required],
        endDate: [new Date(data.date_end), Validators.required]
      });
    } else {
      this.form = this.fb.group({
        startDate: ['', Validators.required],
        endDate: ['', Validators.required]
      });
    }
  }

  setDefaultDateStart() {
    const startDate = this.form.get('startDate').value;
    return startDate || null;
  }

  setDefaultDateEnd() {
    const endDate = this.form.get('endDate').value;
    return endDate || null;
  }

  save() {
    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    const startDate = moment(this.form.get('startDate').value).format('YYYY-MM-DD');
    const endDate = moment(this.form.get('endDate').value).format('YYYY-MM-DD');
    this.associationDates.emit({startDate, endDate});
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/associations-management/associations/association-dates-form/association-dates-form.component.ts